<li class="breadcrumb" [ngSwitch]="type">
  <a *ngSwitchCase="'oldRoute'" [href]="appUris.oldUCUri + oldRoute">
    {{label}}
  </a>
  <a *ngSwitchDefault [routerLink]="route" [class.current-route]="currentRoute">
    {{label}}
  </a>
  <span class="slash" *ngIf="!currentRoute">/</span>
</li>
